import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { fetchCarriersWithFilters } from './store/slice';
import CarrierTopHead from './carriermasters-top-head';
import CarrierContent from './carriermasters-content';
import CarrierModals from './carriermasters-modals';
import { actions as carriersAction } from './store/slice';

const { resetFilters } = carriersAction;

const CarrierView = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchCarriersWithFilters());
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return () => dispatch(resetFilters());
  }, []);

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header transfer">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Carrier</h4>
              </div>
            </div>
            <CarrierTopHead />
          </div>
          <CarrierContent />
          <CarrierModals />
        </div>
      </div>
    </div>
  );
};

export default CarrierView;

